import { useEffect, useState } from "react";
import { api, formatApiError, fmtDateTime } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

function Row({ s, onSaved, path = "ai-limit", prefix = "ai" }) {
  const [v, setV] = useState(String(s.limit));
  const save = async () => {
    try { await api.patch(`/admin/shops/${s.shop_id}/${path}`, { limit: Number(v) }); toast.success("Limite salvo"); onSaved(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <tr className="border-t border-zinc-800" data-testid={`${prefix}-usage-row-${s.shop_id}`}>
      <td className="py-2 pr-2 text-zinc-200">{s.name}</td>
      <td className={`py-2 pr-2 whitespace-nowrap ${s.used >= s.limit ? "text-red-400" : "text-zinc-300"}`}>{s.used}/{s.limit}</td>
      <td className="py-2"><div className="flex gap-1 justify-end"><Input data-testid={`${prefix}-limit-input-${s.shop_id}`} type="number" value={v} onChange={(e) => setV(e.target.value)} className="h-8 w-20 bg-zinc-900 border-zinc-800" />
        <Button data-testid={`${prefix}-limit-save-${s.shop_id}`} size="sm" variant="outline" disabled={v === String(s.limit)} onClick={save} className="h-8 bg-zinc-900 border-zinc-800">Salvar</Button></div></td>
    </tr>
  );
}

export function AssistantUsageAdmin() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/assistant-usage").then(({ data }) => setD(data)).catch(() => setD(null));
  useEffect(() => { load(); }, []);
  if (!d) { return null; }
  return (
    <details data-testid="assistant-usage-admin" className="rounded-2xl border border-card2-border bg-card2 p-4">
      <summary className="cursor-pointer flex items-center gap-2 text-sm font-bold text-zinc-200"><Sparkles className="h-4 w-4 text-amber-300" /> Assistente de relatórios (perguntas/mês) · {d.month} · total {d.shops.reduce((a, s) => a + s.used, 0)}</summary>
      <table className="w-full text-sm mt-3"><thead><tr className="text-[11px] text-zinc-500 text-left"><th>Oficina</th><th>Usado/limite</th><th className="text-right">Limite mensal</th></tr></thead>
        <tbody>{d.shops.map((s) => <Row key={s.shop_id} s={s} onSaved={load} path="assistant-limit" prefix="assistant" />)}</tbody></table>
    </details>
  );
}

export function AiUsageAdmin() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/ai-usage").then(({ data }) => setD(data)).catch(() => setD(null));
  useEffect(() => { load(); }, []);
  if (!d) return null;
  return (
    <details data-testid="ai-usage-admin" className="rounded-2xl border border-card2-border bg-card2 p-4">
      <summary className="cursor-pointer flex items-center gap-2 text-sm font-bold text-zinc-200"><Sparkles className="h-4 w-4 text-amber-300" /> Uso da IA (explicar orçamento) · {d.month} · total {d.shops.reduce((a, s) => a + s.used, 0)}</summary>
      <table className="w-full text-sm mt-3"><thead><tr className="text-[11px] text-zinc-500 text-left"><th>Oficina</th><th>Usado/limite</th><th className="text-right">Limite mensal</th></tr></thead>
        <tbody>{d.shops.map((s) => <Row key={s.shop_id} s={s} onSaved={load} />)}</tbody></table>
      {d.recent.length > 0 && <div className="mt-3 text-xs text-zinc-500 space-y-0.5"><div className="font-bold text-zinc-400">Últimos usos</div>{d.recent.map((r, i) => <div key={i}>{fmtDateTime(r.at)} · {r.shop} · OS #{r.order_number} · {r.items} itens · {r.user}</div>)}</div>}
    </details>
  );
}
